import * as Icons from './icon-definitions';

export const itemIdToIconsMap = {
  205065350: [
    Icons.ADJUSTABLE_DOOR_STORAGE,
    Icons.ICE_MAKER_REMOVABLE_BASKET,
    Icons.FREEZER_TEMP_CONTROL
  ],
  206452443: [
    Icons.DOOR_ALARM,
    Icons.ICE_MAKER_REMOVABLE_BASKET,
    Icons.FREEZER_TEMP_CONTROL
  ],
  302253240: [
    Icons.PRINTPROOF_STAINLESS_STEEL,
    Icons.CRUSHED_CUBED_ICE,
    Icons.SMART_HOME_ENABLED
  ],
  302785353: [
    Icons.FINGERPRINT_RESISTANT,
    Icons.CRUSHED_CUBED_ICE,
    Icons.EXTERNAL_ICE_DISPENSER
  ],
  302786603: [
    Icons.FINGERPRINT_RESISTANT,
    Icons.CRUSHED_CUBED_ICE,
    Icons.EXTERNAL_WATER_DISPENSER
  ],
  308743988: [
    Icons.DOOR_ALARM,
    Icons.CRUSHED_CUBED_ICE,
    Icons.SMART_HOME_ENABLED
  ],
  311411352: [
    Icons.FINGERPRINT_RESISTANT,
    Icons.CRUSHED_CUBED_ICE,
    Icons.SMART_HOME_ENABLED
  ],
  317987058: [
    Icons.DOOR_ALARM,
    Icons.FINGERPRINT_RESISTANT,
    Icons.INTERNAL_WATER_DISPENSER
  ],
  317987099: [
    Icons.DOOR_ALARM,
    Icons.FINGERPRINT_RESISTANT,
    Icons.CRUSHED_CUBED_ICE
  ],
  318840093: [
    Icons.DOOR_ALARM,
    Icons.FINGERPRINT_RESISTANT,
    Icons.CRUSHED_CUBED_ICE
  ],
  319236498: [
    Icons.DOOR_ALARM,
    Icons.FINGERPRINT_RESISTANT,
    Icons.CRUSHED_CUBED_ICE
  ],
  320243591: [
    Icons.ADJUSTABLE_SHELVES,
    Icons.FINGERPRINT_RESISTANT,
    Icons.INTERNAL_WATER_DISPENSER
  ],
  320970662: [
    Icons.DOOR_ALARM,
    Icons.CRUSHED_CUBED_ICE,
    Icons.EXTERNAL_WATER_DISPENSER
  ],
  322038211: [
    Icons.DOOR_ALARM,
    Icons.PRINTPROOF_STAINLESS_STEEL,
    Icons.INTERNAL_ICE_DISPENSER
  ],
  325158253: [
    Icons.DOOR_ALARM,
    Icons.PRINTPROOF_STAINLESS_STEEL,
    Icons.CRUSHED_CUBED_ICE
  ],
  325158262: [
    Icons.DOOR_ALARM,
    Icons.CRUSHED_CUBED_ICE,
    Icons.SMART_HOME_ENABLED
  ],
  326195150: [
    Icons.CRUSHED_CUBED_ICE,
    Icons.EXTERNAL_WATER_DISPENSER,
    Icons.SMART_HOME_ENABLED
  ],
  328604636: [
    Icons.DOOR_ALARM,
    Icons.SMUDGE_PROOF_STAINLESS_STEEL,
    Icons.INTERNAL_WATER_DISPENSER
  ]
};

/**
 * Returns the icon definitions configured for a given item id.
 *
 * @param {string|number} itemId - Product item id used as key into the icon map.
 * @returns {Array<{icon: Function, labels: string[], alt: string}>}
 * The icon entries for the item id, or an empty array when no mapping exists.
 */
export const getIconsByItemId = (itemId) => {
  return itemIdToIconsMap[itemId] ?? [];
};
